import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import PI from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import themeContext from "../../../../context/theme/ThemeContext";
import { validatePhoneNumber } from "../../../../helpers/CommonUtility";
import "../../hospitalStatic.css";
import UserContext from "../../../../context/users/UserContext";
const ReactPhoneInput = PI.default ? PI.default : PI;

const CustomPhoneInput = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const { defaultCountry: tenantDefaultCountry } = useContext(UserContext);
  const defaultCountry = props.defaultCountry || tenantDefaultCountry || "in";
  const [errorCustomState, setErrorCustomState] = useState(props.errorState);
  const [errorBorder, setErrorBorder] = useState(
    props.checkError ? props.errorState : false
  );
  const [t] = useTranslation();

  return (
    <>
      <div className={props.parentClassName}>
        <p className="label-phone">{props.label}</p>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <ReactPhoneInput
            country={defaultCountry}
            name={props.name}
            className={errorBorder ? "error-phone-input" : ""}
            value={props.value}
            countryCodeEditable={false}
            placeholder={t("string-literals.enter-number")}
            dropdownStyle={{
              backgroundColor: getThemeColor("action-details-background"),
              color: getThemeColor("primary-color"),
            }}
            inputStyle={{
              backgroundColor: "transparent",
              //border: "none",
              height: "30.4px",
              width: "100%",
              color: getThemeColor("primary-color"),
              border: "1px solid rgb(88 , 88, 88)",
              borderRadius: "7px"
            }}
            onChange={props.onChangeCustom}
            onKeyDown={(e) => {
              if (
                (e.keyCode >= 48 && e.keyCode <= 57) ||
                (e.keyCode >= 96 && e.keyCode <= 105)
              ) {
                setErrorBorder(false);
                setErrorCustomState(false);
              }
            }}
            isValid={(inputNumber, country, countries) => {
              if(!(errorCustomState && props.errorMessage))
                return validatePhoneNumber(inputNumber, country, t);
              // let targetLength = country.format.match(/\./g).length;
              // let fixedLength = targetLength - country.dialCode.length;
              // let inputTargetLength =
              //   inputNumber.length - country.countryCode.length;
              // if (
              //   inputTargetLength != fixedLength &&
              //   inputNumber.length > country.dialCode.length &&
              //   !(inputNumber.length >= 10 && fixedLength > 10)
              // ) {
              //   //setErrorCustomState(false);
              //   return (
              //     "(" + fixedLength + ` ${t("string-literals.digit-required")})`
              //   );
              // }
            }}
          />
          <div className="custom-error-message">
            {errorCustomState && props.errorMessage}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomPhoneInput;
